module.exports = "<!DOCTYPE html>\n<html>\n    <head>\n        <meta charset=\"UTF-8\">\n        <title>{% block title %}Welcome!{% endblock %}</title>\n        {% block stylesheets %}{% endblock %}\n    </head>\n    <body>\n        {% block body %}{% endblock %}\n        {% block javascripts %}{% endblock %}\n    </body>\n</html>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/template-base-1.txt
// module id = 657
// module chunks = 166022795811749